import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3;
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { calculateRem } from '@vds-core/utilities';
import { ColorTokens } from '@vds-tokens/color';
import { LayoutTokens } from '@vds-tokens/layout';
import BreadcrumbAnchor from './BreadcrumbAnchor';
import BreadcrumbSpan from './BreadcrumbSpan';
var SlashWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "SlashWrapper",
  componentId: "VDS__sc-1m8yc9v-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding-right: ", ";\n  padding-left: ", ";\n  display: flex;\n  align-items: center;\n  outline: none;\n"])), calculateRem(LayoutTokens.space['1X'].value), calculateRem(LayoutTokens.space['1X'].value));
var StyledSlash = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyledSlash",
  componentId: "VDS__sc-1m8yc9v-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (_ref) {
  var color = _ref.color;
  return color;
});
function _renderSeparator(surface) {
  var color = surface === 'dark' ? ColorTokens.elements.primary.ondark.value : ColorTokens.elements.primary.onlight.value;
  return /*#__PURE__*/React.createElement(SlashWrapper, {
    "aria-hidden": true,
    tabIndex: -1
  }, /*#__PURE__*/React.createElement(StyledSlash, {
    "aria-hidden": true,
    tabIndex: -1,
    color: color
  }, "/"));
}
var propTypes = {
  /**
   * Value to be set on the target Attribute of the a tag.
   */
  target: PropTypes.string,
  /**
   * @ignore
   * If selected = false on last breadcrumb it will not render with selected styles
   */
  selected: PropTypes.bool,
  /**
   * If provided, the Breadcrumb will be rendered as a span that is not clickable.
   */
  disabled: PropTypes.bool,
  /**
   * Contents to be displayed in the a tag.
   */
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  /**
   * If provided, used as string that labels the element for accessibility.
   */
  ariaLabel: PropTypes.string,
  /**
   * href to be set as the value of the href Attribute in the a tag.
   */
  href: PropTypes.string,
  /**
   * This function will be called when the TextLink is clicked. It will return an event.
   */
  onClick: PropTypes.func,
  /**
   * @ignore
   * this is the amount of spacing on bottom of breadcrumbs
   */
  margin: PropTypes.string,
  /**
   * @ignore
   */
  surface: PropTypes.oneOf(['light', 'dark']),
  /**
   * Allows a string to be provided for analytics.
   */
  'data-analyticstrack': PropTypes.string,
  /**
   * Allows a string to be provided for analytics.
   */
  'data-track': PropTypes.string,
  /**
   * Allows a string to be provided for ignoring analytics tagging.
   */
  'data-track-ignore': PropTypes.string,
  /**
   * Allows a string to be provided for click stream.
   */
  'data-clickstream': PropTypes.string,
  /**
   * @ignore
   */
  renderSeparator: PropTypes.func,
  /**
   * @ignore
   */
  hoverState: PropTypes.bool
};
var defaultProps = {
  selected: null,
  disabled: null,
  target: '_self',
  surface: 'light',
  hoverState: true,
  renderSeparator: _renderSeparator,
  onClick: undefined
};
var StyledBreadcrumb = /*#__PURE__*/styled.li.withConfig({
  displayName: "StyledBreadcrumb",
  componentId: "VDS__sc-1m8yc9v-2"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  align-items: center;\n  color: ", ";\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  margin-bottom: ", "px;\n  margin-top: ", "px;\n"])), function (_ref2) {
  var surface = _ref2.surface;
  return surface === 'dark' ? ColorTokens.elements.primary.ondark.value : ColorTokens.elements.secondary.onlight.value;
}, parseInt(LayoutTokens.space['1X'].value, 10) / 2, parseInt(LayoutTokens.space['1X'].value, 10) / 2);

// const BreadcrumbItem = props => {
export var BreadcrumbItem = /*#__PURE__*/function (_Component) {
  _inherits(BreadcrumbItem, _Component);
  var _super = _createSuper(BreadcrumbItem);
  function BreadcrumbItem() {
    _classCallCheck(this, BreadcrumbItem);
    return _super.apply(this, arguments);
  }
  _createClass(BreadcrumbItem, [{
    key: "render",
    value:
    /*
     * If the BreadCrumb is selected or disabled, it should be a <span>, otherwise it should be an <a>
     * <a> tags cannot truly be "disabled", so using a <span> increases accessibility
     */

    function render() {
      var _this$props = this.props,
        selected = _this$props.selected,
        children = _this$props.children,
        ariaLabel = _this$props.ariaLabel,
        lastChild = _this$props.lastChild,
        surface = _this$props.surface,
        analyticsTrack = _this$props['data-analyticstrack'],
        track = _this$props['data-track'],
        trackIgnore = _this$props['data-track-ignore'],
        clickStream = _this$props['data-clickstream'],
        renderSeparator = _this$props.renderSeparator,
        color = _this$props.color,
        hoverState = _this$props.hoverState,
        focusRingBorderRadius = _this$props.focusRingBorderRadius;
      var BreadcrumbComponent = selected && lastChild || this.props.disabled ? BreadcrumbSpan : BreadcrumbAnchor;
      return /*#__PURE__*/React.createElement(StyledBreadcrumb, {
        surface: surface
      }, /*#__PURE__*/React.createElement(BreadcrumbComponent, _extends({}, this.props, {
        ariaLabel: ariaLabel,
        tabIndex: 1,
        color: color,
        "data-analyticstrack": analyticsTrack,
        "data-track": track,
        "data-track-ignore": trackIgnore,
        "data-clickstream": clickStream,
        surface: surface,
        hoverState: hoverState,
        focusRingBorderRadius: focusRingBorderRadius
      }), children), !selected && !lastChild && !!renderSeparator && renderSeparator(surface));
    }
  }]);
  return BreadcrumbItem;
}(Component);
BreadcrumbItem.propTypes = propTypes;
BreadcrumbItem.defaultProps = defaultProps;
export default BreadcrumbItem;